import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const GoodMorningIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 50 39" {...props}>
      <path
        d="M26 9C20.4772 9 16 13.4772 16 19C16 20.4222 16.2969 21.7751 16.8321 23H35.1679C35.7031 21.7751 36 20.4222 36 19C36 13.4772 31.5228 9 26 9Z"
        fill="#FFD900"
      />
      <path
        d="M30.4012 23H35.2013C35.715 21.7754 36 20.4219 36 19C36 13.4775 31.7019 9 26.4 9C25.5712 9 24.7671 9.10938 24 9.31543C28.1406 10.4258 31.2 14.3408 31.2 19C31.2 20.4219 30.915 21.7754 30.4012 23Z"
        fill="#FFBB00"
      />
      <path
        d="M8 19H12.5M13 6.5L16.5 9.5M26 1V6M35.5 9L39 5.5M39.5 19.5H44"
        stroke="#FFBB00"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1 23H49"
        stroke="#81AEC4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4 28H12"
        stroke="#81AEC4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16 28H47.5"
        stroke="#81AEC4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7 33H44.5"
        stroke="#81AEC4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5 38H47.5"
        stroke="#81AEC4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export default GoodMorningIcon;
